<p class="e11-text-skin-light e11-mb-0 e11-text-sm">© {{ yearCurrent }} Cnect, Inc. {{ 'All rights reserved.' | translate }}</p>
